
<template>
  <div class="Content">
    <div  class="bar1" :id="echartsId"></div>
  </div>
</template>
<script>
import { getSlice } from "@/utils/index";
import uuidv1 from "uuid/v1";
export default {
  props: {
    barDatedd: {
      //echarts数据
      type: Object, //类型对象
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      objdata: "",
      echartsId:uuidv1(),
    };
  },
  created() {},
  watch: {
    barDatedd(newVal, oldVal) {
         {
            this.objdata = this.initData(newVal);
            this.fillYearEcharts(this.objdata);
        }
    }
  },
  mounted() {
      let vm=this
    vm.objdata = vm.initData(vm.barDatedd);
    vm.fillYearEcharts(vm.objdata);
    vm.bus.$on("barChartClick", res => {
        let series=vm.getSeries(res)
        vm.myChart.setOption({
            series:series,
            title:{
                text: res.timeTitle,
                left: "center"
            }
        })
    });
  },
  methods: {
    getSeries(val){
        let seData = [];
          if (val.dateType == "2") {
            seData = [
              {
                name: "峰期电量(kWh)",
                type: "bar",
                data: val.seriesData[0]
              },
              {
                name: "平期电量(kWh)",
                type: "bar",
                data: val.seriesData[1]
              },
              {
                name: "谷期电量(kWh)",
                type: "bar",
                data: val.seriesData[2]
              }
            ];
          } else {
            seData = [
              {
                name: "峰期电量(kWh)",
                type: "bar",
                data: val.seriesData[0],
                stack: "电量"
              },
              {
                name: "平期电量(kWh)",
                type: "bar",
                data: val.seriesData[1],
                stack: "电量"
              },
              {
                name: "谷期电量(kWh)",
                type: "bar",
                data: val.seriesData[2],
                stack: "电量"
              }
            ];
          }
          return seData;
    },
    initData(curval) {
      let obj = {
        x: curval.xdata,
        title:curval.timeTitle,
        series: this.getSeries(curval)
      };
      return obj;
    },
    fillYearEcharts(obj) {
      let this_ = this;
      if (
        this_.myChart != null &&
        this_.myChart != "" &&
        this_.myChart != undefined
      ) {
        this_.myChart.dispose();
      }
      this.myChart = this.$echarts.init(document.getElementById(this.echartsId));
      var option = {
        tooltip: {
          trigger: "axis",
          confine: true
        },
        title: {
          text: obj.title,
          left: "center"
        },
        color: ["#d4953e", "#78b1e9", "#6ea562", "#e8855b", "#DC143C"],
        grid: {
          left: "10",
          right: "10",
          bottom: "1%",
          top: "15%",
          show: true,
          borderColor: "#dce1e7",
          containLabel: true
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {}
          }
        },
        legend: {
          data: ["峰期电量(kWh)", "平期电量(kWh)", "谷期电量(kWh)"],
          top: "5%",
          textStyle:{
              color:"#666"
          }
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: '#666'
            }
          }
        ],
        xAxis: [
          {
            type: "category",
            data: obj.x,
            axisLabel: {
              color: '#666'
            }
          }
        ],
        series: obj.series
      };
      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
      //点击事件
    //   this.myChart.on("click", function(params) {
    //     // var name = parseInt(params.name);
    //   });
    }
  }
};
</script>
<style lang="scss" scoped>
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
// #bar1 {
//   width: 100%;
//   height: 100%;
//   overflow: hidden;
// }
.bar1 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.Content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid #ccd7e8;
  border-radius: 10px;
}
.count {
  position: absolute;
  top: 2rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  box-sizing: border-box;
}
.countUl {
  list-style: none;
  overflow: hidden;
  display: flex;
  margin-left: 5%;
  margin: 0px;
  height: 20px;
  margin-top: 11px;
  padding-left: 26px;
}
.countUl li {
  font-size: 0.1rem;
  line-height: 1.2rem;
  box-sizing: border-box;
  margin-right: 10px;
  text-align: center;
  width: 100px;
}
.parentflex {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
  padding-top: 1px;
}
.parentflex > p {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.2rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.content {
  position: absolute;
  top: 35px;
  bottom: 5px;
  left: 5px;
  right: 5px;
}
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 1px;
}
canvas {
  height: 100%;
}
</style>